import { TableRow } from '@aon/aon-tws-common-ui';
import React from 'react';
import { ISurveyQuestionEditModel } from '../../../models';

export interface IDimensionQuestionTableRowProps {
	question: ISurveyQuestionEditModel;
	isSelected: boolean;
	allowSelection: boolean;
	onQuestionSelectionChange: (question: ISurveyQuestionEditModel, isSelected: boolean) => void;
}

const DimensionQuestionTableRow = ({
	question,
	isSelected,
	allowSelection,
	onQuestionSelectionChange,
}: IDimensionQuestionTableRowProps) => {
	return (
		<TableRow
			key={question.surveyQuestionId}
			selectable={true}
			selected={isSelected}
			disabled={!allowSelection}
			onSelectRow={() => onQuestionSelectionChange(question, !isSelected)}
		>
			<td>{question.text}</td>
			<td>{question.responseOptionGroup}</td>
		</TableRow>
	);
};

export default DimensionQuestionTableRow;
